import PopularTestsSection from 'components/Homepage/PopularTestsSection';
import React, { useEffect, useContext } from 'react';
import { CTA, ListOfContentWithImages } from 'utils/types';

import { ProductInfoContext } from '../../../templates/homepage';
export interface PopularTestsContainerProps {
  content: {
    headline: string;
    mainCta: CTA;
    listOfContentWithImages: ListOfContentWithImages[];
  };
}

export const PopularTestsContainer = ({
  content,
}: PopularTestsContainerProps): JSX.Element | null => {
  const productsBySlug = useContext(ProductInfoContext);

  // necessary for SSR https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [hasMounted, setHasMounted] = React.useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!content) {
    return null;
  }

  const { headline, mainCta, listOfContentWithImages } = content;

  const formattedListOfContent = listOfContentWithImages.map((item) => {
    const product = productsBySlug[item.identifier];

    return {
      heading: product?.name,
      subheading: `$${Number(product?.price).toFixed()}`,
      callout: item.callout,
      image: product?.boxImage?.gatsbyImageData,
      number: product?.productId,
      slug: item?.identifier || '',
      showRating: true,
      description: item?.description?.description,
      reviewData: {
        numOfReviews: product?.reviewData?.review_count,
        rating: product?.reviewData?.average_rating,
      },
    };
  });

  if (!hasMounted) {
    return null;
  }

  return (
    <PopularTestsSection
      headline={headline}
      mainCta={mainCta}
      listOfContent={formattedListOfContent}
      productsBySlug={productsBySlug}
    />
  );
};

export default PopularTestsContainer;
